import React from 'react';

export default function GioiThieu() {
  return (
    <>

<div className="bg-white text-gray-800 py-12 px-4 md:px-8 lg:px-16 max-w-7xl mx-auto mt-16">
      <div className="text-center mb-10">
        <h1 className="text-3xl md:text-4xl font-bold text-pink-600 uppercase">Về Chúng Tôi</h1>
        <p className="mt-4 text-gray-600 text-base md:text-lg">
          Câu chuyện thương hiệu thời trang PT2000 – Nơi khơi nguồn phong cách cá nhân cho giới trẻ Việt.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-1 gap-10 items-center">
        {/* <div>
          <img
            src="/images/about-pt2000.jpg"
            alt="Cửa hàng PT2000"
            className="rounded-xl shadow-md w-full"
          />
        </div> */}
        <div>
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Thương hiệu thời trang tiên phong từ năm 1999</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            PT2000 là thương hiệu thời trang mang đậm dấu ấn Việt, được thành lập với sứ mệnh mang đến phong cách trẻ trung, hiện đại và dễ tiếp cận cho giới trẻ. Từ những ngày đầu, PT2000 đã không ngừng phát triển và khẳng định vị thế tại thị trường thời trang nội địa.
          </p>
          <p className="text-gray-700 leading-relaxed mb-4">
            PT2000 không ngừng cập nhật xu hướng thời trang mới nhất, cùng đội ngũ thiết kế và sản xuất chuyên nghiệp tại Việt Nam.
          </p>
          <p className="text-gray-700 leading-relaxed">
            Mỗi sản phẩm của PT2000 đều được chăm chút kỹ lưỡng từ chất liệu đến kiểu dáng, mang đến trải nghiệm tốt nhất cho người mặc – từ trang phục thường ngày đến các dòng thời trang công sở và streetwear.
          </p>
        </div>
      </div>

      <div className="mt-16 text-center">
        <h3 className="text-2xl font-bold text-gray-900">PT2000 - Đồng hành cùng phong cách Việt</h3>
        <p className="mt-4 text-gray-600 max-w-3xl mx-auto">
          Hãy để PT2000 là người bạn đồng hành cùng bạn trong hành trình thể hiện cá tính và phong cách riêng. Truy cập <a href="https://pt2000.com.vn" className="text-pink-600 underline">pt2000.com.vn</a> hoặc ghé thăm cửa hàng gần nhất để trải nghiệm ngay hôm nay!
        </p>
      </div>
    </div>

    </>
    
  );
};

